import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './dish-portions-counter.scss';

export default function DishPortionCounter(props) {
    const { portion } = props;

    const countClasses = classNames({
        [s['ny__dish__counter-container']]: true,
        [s.visible]: portion > 0,
    });

    return (
        <div className={countClasses}>
            <span className="ny__dish__counter-text">
                {portion || 1}
            </span>
        </div>
    );
}

DishPortionCounter.propTypes = {
    portion: PropTypes.number.isRequired,
};
